import classNames from "classnames";
import React from "react";
import { Icon } from "../../graphic/Icon";
import styles from "./SiteFeature.scss";

/**
 * Two-column feature row: copy on one side, a visual (children) on the other
 * @param highlight – a key point below the text, with a check mark
 * @param highlights – several key points, as a check list (instead of `highlight`)
 * @param reverse – puts the copy on the right on larger screens
 */
export const SiteFeature = ({ eyebrow, title, text, highlight, highlights, reverse, children }) => {
    const points = highlights || (highlight ? [highlight] : []);

    return (
        <section className={styles.base}>
            <div className={classNames(styles.grid, { [styles.reverse]: reverse })}>
                <div className={styles.copy}>
                    <p className={styles.eyebrow}>{eyebrow}</p>
                    <h2 className={styles.title}>{title}</h2>
                    <p className={styles.text}>{text}</p>
                    {points.length ? (
                        <ul className={styles.highlights}>
                            {points.map((point, index) => (
                                <li key={index} className={styles.highlight}>
                                    <Icon name="check" />
                                    {point}
                                </li>
                            ))}
                        </ul>
                    ) : null}
                </div>
                {children}
            </div>
        </section>
    );
};
